// Sentry is loaded lazily after LCP to keep it off the critical path.
// See components/lazy-sentry.tsx for the deferred initialization.

// Patches Node.prototype.removeChild / insertBefore so React's commit phase
// survives DOM mutations from in-browser translators (Google Translate etc.).
// Must run before hydration — instrumentation-client.ts is the earliest hook.
import { applyTranslatorDomSafeguard } from '~/components/polyfills/translator-dom-safeguard';

applyTranslatorDomSafeguard();
